import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id } from '@feature/utils';
import { Validation } from '@feature/validation';
import { generateValidationApi, generateValidationOptions } from '@feature/validation/validationGenerator';

const validationApi = generateValidationApi('/validation/award');

const { getHistoryOptions, validateOptions, getCurrentOptions } = generateValidationOptions('award', validationApi);

export function getAwardValidationHistoryOptions(awardId: Id): UseSuspenseQueryOptions<Validation[]> {
  return getHistoryOptions(awardId);
}

export function getAwardValidationOptions(awardId: Id): UseSuspenseQueryOptions<Validation | null> {
  return getCurrentOptions(awardId);
}

export function useValidateAward(awardId: Id) {
  const queryClient = useQueryClient();
  return useMutation(validateOptions(awardId, queryClient));
}
